import { render, staticRenderFns } from "./base-navbar.vue?vue&type=template&id=d0b137a6"
import script from "./base-navbar.vue?vue&type=script&lang=js"
export * from "./base-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports